<template>
  <div class="page-main">

    <!-- 左侧固定分享面板 -->
    <div class="article-share-panel">
      <div class="share-item" @click="copyArticleLink">
        <svg class="share-item-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.35321 13.1314C3.83017 14.6544 3.83017 17.1238 5.35321 18.6468C6.87625 20.1699 9.3456 20.1699 10.8686 18.6468L12.4007 17.1148C12.635 16.8804 13.0149 16.8804 13.2492 17.1148C13.4836 17.3491 13.4836 17.729 13.2492 17.9633L11.7172 19.4953C9.7255 21.487 6.49636 21.487 4.50468 19.4953C2.51301 17.5037 2.51301 14.2745 4.50468 12.2829L6.03675 10.7508C6.27106 10.5165 6.65096 10.5165 6.88527 10.7508C7.11959 10.9851 7.11959 11.365 6.88528 11.5993L5.35321 13.1314ZM10.7508 6.88527C10.5165 6.65096 10.5165 6.27106 10.7508 6.03674L12.2829 4.50468C14.2745 2.513 17.5037 2.51301 19.4953 4.50468C21.487 6.49635 21.487 9.7255 19.4953 11.7172L17.9633 13.2492C17.729 13.4835 17.3491 13.4835 17.1148 13.2492C16.8804 13.0149 16.8804 12.635 17.1148 12.4007L18.6468 10.8686C20.1699 9.3456 20.1699 6.87625 18.6468 5.35321C17.1238 3.83016 14.6544 3.83016 13.1314 5.35321L11.5993 6.88527C11.365 7.11959 10.9851 7.11959 10.7508 6.88527ZM9.21873 14.7813C8.98441 14.547 8.98441 14.1671 9.21873 13.9328L13.9328 9.21872C14.1671 8.98441 14.547 8.98441 14.7813 9.21872C15.0156 9.45304 15.0156 9.83294 14.7813 10.0673L10.0673 14.7813C9.83294 15.0156 9.45304 15.0156 9.21873 14.7813Z"
            fill="currentColor"
            fill-rule="evenodd"
            clip-rule="evenodd"
          />
        </svg>
        <span>复制链接</span>
      </div>

      <div class="share-item" @click="shareArticleWechat">
        <img class="share-item-icon" :src="wechatIcon" alt="微信" />
        <span>微信好友</span>
      </div>

      <div class="share-item" @click="shareArticleQQ">
        <img class="share-item-icon" :src="qqIcon" alt="QQ" />
        <span>QQ好友</span>
      </div>

      <div class="share-item" @click="shareArticleWeibo">
        <img class="share-item-icon" :src="weiboIcon" alt="微博" />
        <span>微博</span>
      </div>
    </div>

    <!-- 主体左右双栏 -->
    <div class="main-body flex-row">

      <!-- 左侧区域 宽度1042px -->
      <div class="main-left flex-col">

        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <span class="home-link" @click="goHome">中国品牌网</span>
          <span class="sep">&gt;</span>
          <span class="channel-link" v-if="article.templatePath && article.categoryId" @click="goCategory(article.categoryId)">
            {{ article.categoryName || '频道' }}
          </span>
          <span class="sep">&gt; 正文</span>
        </div>
        <!-- 1. 文章标题 + 字体切换 -->
        <div class="box_65 flex-col justify-between">
          <div class="text-group_42 flex-col justify-between">
            <span class="text_22">{{ article.title || '加载中...' }}</span>
            <span v-if="article.subtitle" class="article-subtitle">{{ article.subtitle }}</span>
            <div class="text-wrapper_3 article-meta-row">
              <div class="article-meta-left">
                <span class="text_23" v-if="article.author">{{ article.author }}</span>
                <span class="text_24" v-if="article.author">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="text_25">{{ article.publishTimeStr }}</span>
              </div>
              <span v-if="article.source" class="text_25 article-meta-source">来源：{{ article.source.split('|')[0] }}</span>
            </div>
          </div>
          <!-- 字体大小切换 -->
          <div class="box_48 flex-row">
            <div class="font-size-icon flex-col justify-center" style="background:rgba(175,0,14,1);border-radius:50%;width:55px;height:45px;flex-shrink:0;margin-left:-1px;display:flex;align-items:center;justify-content:center;">
              <img class="image_15" referrerpolicy="no-referrer" :src="require('../assets/img/FigmaDDSSlicePNGd1a7e31ce94b33ee74a4e1181d08180e.png')" />
            </div>
            <div class="text-wrapper_25">
              <span class="font-size-btn" :class="{ active: fontSize === 22 }" @click="fontSize = 22">最大</span>
              <span class="font-size-btn" :class="{ active: fontSize === 18 }" @click="fontSize = 18">大</span>
              <span class="font-size-btn" :class="{ active: fontSize === 16 }" @click="fontSize = 16">中</span>
              <span class="font-size-btn" :class="{ active: fontSize === 14 }" @click="fontSize = 14">小</span>
            </div>
          </div>
        </div>

        <!-- 2. 文章内容 -->
        <div class="box_68 flex-col" ref="articleContent" :style="{ fontSize: fontSize + 'px' }">

          <!-- 图页模式：newsImages 不为空 -->
          <template v-if="article.newsImages && article.newsImages.length > 0">
            <div class="img-page-wrap">
              <!-- 图片展示区 -->
              <div class="img-page-viewer">
                <button class="img-page-arrow img-page-arrow-left" :disabled="imgPageIdx === 0" @click="imgPageIdx--">&#8592;</button>
                <div class="img-page-content">
                  <img
                    class="img-page-img"
                    referrerpolicy="no-referrer"
                    :src="article.newsImages[imgPageIdx].imageUrl"
                    :alt="article.newsImages[imgPageIdx].imageAlt || ''"
                  />
                  <div class="img-page-desc" :style="{ fontSize: imgPageDescFontSize }" v-html="article.newsImages[imgPageIdx].imageDesc"></div>
                </div>
                <button class="img-page-arrow img-page-arrow-right" :disabled="imgPageIdx === article.newsImages.length - 1" @click="imgPageIdx++">&#8594;</button>
              </div>
              <!-- 页码 -->
              <div class="img-page-counter">{{ imgPageIdx + 1 }} / {{ article.newsImages.length }}</div>
            </div>
          </template>

          <!-- 富文本模式：newsImages 为空，只显示 content -->
          <template v-else>
            <div class="paragraph_1" v-html="article.content"></div>
          </template>

          <!-- 审核信息栏 -->
          <div v-if="article.publisherName || article.approvalOneBy || article.approvalTwoBy || article.approvalThreeBy" class="article-approval-bar">
            <span v-if="article.publisherName">{{ article.publisherPostName }}：{{ article.publisherName }}</span>
            <span v-if="article.approvalOneBy">一审：{{ article.approvalOneBy }}</span>
            <span v-if="article.approvalTwoBy">二审：{{ article.approvalTwoBy }}</span>
            <span v-if="article.approvalThreeBy">三审：{{ article.approvalThreeBy }}</span>
            <button @click="checkLoginThenShowFeedbackModal" class="feedback-btn">反馈意见</button>
          </div>

        </div>

        <!-- 3. 评论区 -->
        <div class="section-comment" style="margin-top: 30px;">

          <!-- 已登录：显示头像+昵称+输入框 -->
          <template v-if="userInfo.nickname">
            <div class="comment-write-row">
              <img
                class="user-avatar"
                referrerpolicy="no-referrer"
                :src="userInfo.avatar || require('../assets/img/FigmaDDSSlicePNGe9b1e461f09f428f813ac2f33705954d.png')"
              />
              <div class="comment-write-right">
                <span class="comment-user-name">{{ userInfo.nickname }}</span>
                <div class="text-wrapper_13 flex-col">
                  <textarea ref="commentInput" class="comment-input" placeholder="写评论..." :maxlength="500" v-model="commentText"></textarea>
                </div>
              </div>
            </div>
          </template>

          <!-- 未登录：默认小人头像 + 提示登录 -->
          <template v-else>
            <div class="comment-write-row comment-nologin-row">
              <img
                class="user-avatar"
                referrerpolicy="no-referrer"
                :src="require('../assets/img/default_avatar.png')"
              />
              <div class="comment-nologin-box">
                请先 <span class="comment-login-link" @click="goLogin">登录</span> 后发表评论~
              </div>
            </div>
          </template>

          <!-- 评论操作 + 列表 -->
          <div class="section_16 flex-col">
            <div v-if="userInfo.nickname" class="box_74 flex-row justify-between">
              <span class="text_56" :class="{ 'count-full': commentText.length >= 500 }">{{ commentText.length }}/500</span>
              <div class="text-wrapper_14 flex-col" @click="submitComment"><span class="text_57" :class="{ 'disabled': commentLoading }">发表{{ commentLoading ? 'ing...' : '' }}</span></div>
            </div>
            <span class="text_58">热评论（{{ commentTotal }}）</span>

            <!-- 评论列表 -->
            <div v-for="(comment, idx) in commentList" :key="comment.id" class="comment-item">
              <div class="image-text_37 flex-row">
                <img class="label_6 ci-avatar" referrerpolicy="no-referrer"
                  :src="comment.avatar || 'https://image.cbrand.com.cn/tmp/a35f6d318d63902f817176097c6ca690.png'"
                  @click="showReportModal('userAvatar', comment)"
                  style="cursor: pointer;" />
                <div class="ci-right flex-col">
                  <span class="text_59" @click="showReportModal('userNickname', comment)" style="cursor: pointer;">{{ comment.nickname }}</span>
                  <span class="text_60" @click="showReportModal('', comment)" style="cursor: pointer;">{{ comment.content }}</span>
                  <div class="comment-actions flex-row">
                    <span class="comment-time">
                     {{ formatRelativeTime(comment.createTime) }} . <template v-if="comment.province">{{ comment.province }}</template>
                    </span>
                    <div class="action-btns flex-row">
                      <span class="action-btn" :class="{ 'action-active': comment.isUp === 1 }" @click="toggleLike(idx)">
                        <svg v-if="comment.isUp !== 1" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 22V11M2 13v7a2 2 0 002 2h11.172a2 2 0 001.945-1.535l1.526-6.12A2 2 0 0016.696 11H13V7a3 3 0 00-3-3H9l-2 4v14z" stroke="#999" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 22V11M2 13v7a2 2 0 002 2h11.172a2 2 0 001.945-1.535l1.526-6.12A2 2 0 0016.696 11H13V7a3 3 0 00-3-3H9l-2 4v14z" stroke="#a00000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="#ffe0e0"/>
                        </svg>
                        <span>{{ comment.upCount }}</span>
                      </span>
                      <span class="action-btn" :class="{ 'action-dislike-active': comment.isDown === 1 }" @click="toggleDislike(idx)">
                        <svg v-if="comment.isDown !== 1" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17 2v11M22 11V4a2 2 0 00-2-2H8.828a2 2 0 00-1.945 1.535l-1.526 6.12A2 2 0 007.304 13H11v4a3 3 0 003 3h1l2-4V2z" stroke="#999" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17 2v11M22 11V4a2 2 0 00-2-2H8.828a2 2 0 00-1.945 1.535l-1.526 6.12A2 2 0 007.304 13H11v4a3 3 0 003 3h1l2-4V2z" stroke="#0064c8" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="#ddeeff"/>
                        </svg>
                        <span>{{ comment.downCount }}</span>
                      </span>
                      <span class="action-btn reply-btn" @click="toggleReply(idx)">
                        {{ comment.showReply ? '取消' : '回复' }}
                      </span>
                      <!-- 举报按钮 (非当前用户的评论) -->
                      <span v-if="comment.userId && comment.userId != userInfo.userCode" class="action-btn report-btn" @click.stop="showReportModal('content', comment)" title="举报">
                        举报
                      </span>
                    </div>
                  </div>

                  <!-- 回复输入框 -->
                  <div v-if="comment.showReply" class="reply-box">
                    <div class="text-wrapper_15 flex-col">
                      <textarea class="comment-input reply-input" placeholder="写评论" :maxlength="500" v-model="comment.replyText"></textarea>
                    </div>
                    <div class="box_76 flex-row justify-between">
                      <span class="text_65" :class="{ 'count-full': (comment.replyText || '').length >= 500 }">{{ (comment.replyText || '').length }}/500</span>
                      <div class="text-wrapper_16 flex-col" @click="submitReply(idx)"><span class="text_66">发&nbsp;表</span></div>
                    </div>
                  </div>

                  <!-- 嵌套回复列表 -->
                  <div v-if="comment.replyList && comment.replyList.length > 0" class="reply-list">
                    <div v-for="reply in comment.replyList" :key="reply.id" class="reply-item flex-row">
                      <img class="reply-avatar" referrerpolicy="no-referrer"
                        :src="reply.avatar || require('../assets/img/default_avatar.png')" />
                      <div class="reply-right flex-col">
                        <span class="reply-nickname">{{ reply.nickname }}</span>
                        <span class="reply-content">{{ reply.content }}</span>
                        <span class="reply-time">
                          <template v-if="reply.province">{{ reply.province }} · </template>{{ formatRelativeTime(reply.createTime) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 滚动加载哨兵 -->
            <div ref="commentSentinel" class="comment-sentinel"></div>
            <div v-if="commentLoading" class="comment-loading">加载中...</div>

          </div>
        </div>

        <!-- 4. 推荐新闻（4卡片） -->
        <div class="recommend-card-list">
          <div v-for="(item, index) in recommendList" :key="'recommend-' + index" class="recommend-card">
            <div class="recommend-image-wrap" @click="goDetail(item.newsCode)">
              <img class="recommend-image" referrerpolicy="no-referrer" :alt="item.title"  @error="(e) => e.target.src = DEFAULT_IMAGE" :src="item.coverImage || DEFAULT_IMAGE" />
            </div>
            <div class="recommend-info">
              <span class="recommend-category">{{ getSource(item.source || '中国品牌') }}</span>
            </div>
            <div class="recommend-title" @click="goDetail(item.newsCode)">{{ item.title }}</div>
            <div class="recommend-actions flex-row" style="margin-top: 30px;">
              <ShareButton :news-code="item.newsCode" :title="item.title" />
              <FavoriteButton :news-id="item.id" />
            </div>
          </div>
        </div>

      </div>
      <!-- /左侧 -->

      <!-- 右侧区域 宽度323px -->
      <div class="main-right flex-col">

        <!-- 1. 杂志月份模块（封面图 + 月份选择器） -->
        <IssuePanel />

        <!-- 2. 热点榜 -->
        <HotList />

        <!-- 3. 广告位（动态） -->
        <div class="sidebar-ads">
          <a
            v-for="(ad, idx) in adList"
            :key="'ad-' + idx"
            :href="ad.turnUrl"
            target="_blank"
            class="sidebar-ad-item"
          >
            <img
              class="sidebar-ad-img"
              referrerpolicy="no-referrer"
              :src="ad.imageUrl"
              :alt="ad.textTip || '广告'"
            />
            <span v-if="ad.isShowTag === 1" class="sidebar-ad-tag">广告</span>
          </a>
        </div>

      </div>
      <!-- /右侧 -->

    </div>
    <!-- /主体双栏 -->

    <!-- 合作品牌栏 -->
    <HomePartners style="margin-bottom: 30px;" />

    <!-- 反馈意见弹窗 -->
    <div v-if="showFeedbackModal" class="modal-mask" @click.self="showFeedbackModal = false">
      <div class="feedback-modal">
        <h3 class="feedback-title">反馈意见</h3>
        
        <!-- 反馈类型 -->
        <div class="feedback-row">
          <label class="feedback-label">反馈类型<span class="required">*</span></label>
          <div class="feedback-options">
            <label class="radio-option">
              <input type="radio" name="feedbackType" value="1" v-model="feedbackForm.type" />
              <span>不实信息</span>
            </label>
            <label class="radio-option">
              <input type="radio" name="feedbackType" value="2" v-model="feedbackForm.type" />
              <span>侵权相关</span>
            </label>
            <label class="radio-option">
              <input type="radio" name="feedbackType" value="3" v-model="feedbackForm.type" />
              <span>栏目不宜</span>
            </label>
            <label class="radio-option">
              <input type="radio" name="feedbackType" value="4" v-model="feedbackForm.type" />
              <span>内容有误</span>
            </label>
            <label class="radio-option">
              <input type="radio" name="feedbackType" value="5" v-model="feedbackForm.type" />
              <span>其他</span>
            </label>
          </div>
        </div>

        <!-- 反馈说明 -->
        <div class="feedback-row">
          <label class="feedback-label">反馈说明</label>
          <textarea
            v-model="feedbackForm.content"
            placeholder="请输入反馈说明（选填）"
            maxlength="500"
            rows="4"
          ></textarea>
          <div class="char-count">{{ feedbackForm.content.length }}/500</div>
        </div>

        <!-- 联系电话 -->
        <div class="feedback-row">
          <label class="feedback-label">联系电话</label>
          <div class="input-wrapper">
            <input
              type="tel"
              v-model="feedbackForm.mobile"
              placeholder="请输入联系电话（选填）"
              maxlength="11"
              class="feedback-input"
            />
          </div>
        </div>

        <!-- 邮箱 -->
        <div class="feedback-row">
          <label class="feedback-label">您的邮箱</label>
          <div class="input-wrapper">
            <input
              type="email"
              v-model="feedbackForm.email"
              placeholder="请输入邮箱（选填）"
              class="feedback-input"
            />
          </div>
        </div>

        <!-- 验证码 -->
        <div class="feedback-row">
          <label class="feedback-label">验证码</label>
          <div class="captcha-row">
            <input
              v-model="feedbackForm.captchaCode"
              type="text"
              placeholder="请输入图片验证码"
              maxlength="4"
              class="feedback-input captcha-input"
            />
            <img
              v-if="captchaUrl"
              :src="captchaUrl"
              alt="验证码"
              @click="loadCaptcha"
              class="captcha-img"
            />
          </div>
          <div v-if="feedbackForm.errors.captcha" class="captcha-error">
            <span>{{ feedbackForm.errors.captcha }}</span>
          </div>
        </div>

        <!-- 底部按钮 -->
        <div class="feedback-actions">
          <button @click="submitFeedback" class="btn-submit" :disabled="feedbackLoading">{{ feedbackLoading ? '提交中...' : '提交' }}</button>
          <button @click="showFeedbackModal = false" class="btn-cancel" :disabled="feedbackLoading">取消</button>
        </div>
      </div>
    </div>

    <!-- 举报弹窗 -->
    <div v-if="showReportModalVisible" class="modal-mask" @click.self="showReportModalVisible = false">
      <div class="feedback-modal">
        <h3 class="feedback-title">举报</h3>
        
        <!-- 举报内容 -->
        <div class="feedback-row">
          <label class="feedback-label">举报内容<span class="required">*</span></label>
          <div class="report-content-type" style="display: flex; gap: 20px; margin-top: 6px;">
            <label class="radio-option">
              <input type="radio" name="reportContent" value="1" v-model="reportModalData.contentTargetType" />
              <span>用户头像</span>
            </label>
            <label class="radio-option">
              <input type="radio" name="reportContent" value="2" v-model="reportModalData.contentTargetType" />
              <span>用户昵称</span>
            </label>
            <label class="radio-option">
              <input type="radio" name="reportContent" value="3" v-model="reportModalData.contentTargetType" />
              <span>评论内容</span>
            </label>
          </div>
        </div>
        
        <!-- 举报类型 -->
        <div class="feedback-row">
          <label class="feedback-label">举报类型<span class="required">*</span></label>
          <div class="feedback-options">
            <label class="radio-option" v-for="(type, idx) in reportTypes" :key="idx">
              <input type="radio" :name="'reportType-' + idx" :value="type.value" v-model="reportModalData.type" />
              <span>{{ type.label }}</span>
            </label>
          </div>
        </div>

        <!-- 补充说明 -->
        <div class="feedback-row">
          <label class="feedback-label">补充说明</label>
          <textarea
            v-model="reportModalData.desc"
            placeholder="请输入补充说明（选填，限 200 个字符）"
            maxlength="200"
            rows="4"
          ></textarea>
          <div class="char-count">{{ reportModalData.desc.length }}/200</div>
        </div>

        <!-- 底部按钮 -->
        <div class="feedback-actions">
          <button @click="submitReport" class="btn-submit" :disabled="reportLoading">{{ reportLoading ? '提交中...' : '提交' }}</button>
          <button @click="showReportModalVisible = false" class="btn-cancel" :disabled="reportLoading">取消</button>
        </div>
      </div>
    </div>

    <!-- 文章分享二维码弹层 -->
    <div v-if="showArticleShareQrcode" class="qrcode-mask" @click.self="showArticleShareQrcode = false">
      <div class="qrcode-box">
        <div class="qrcode-title">{{ articleQrcodeTitle }}</div>
        <img class="qrcode-img" :src="articleQrcodeUrl" alt="二维码" />
        <div class="qrcode-tip">{{ articleQrcodeTip }}</div>
        <div class="qrcode-close" @click.self="showArticleShareQrcode = false">关闭</div>
      </div>
    </div>

    <!-- 消息弹层 -->
    <div class="toast-mask" v-if="toast.show" @click.self="hideToast">
      <div class="toast-content" :class="toast.type">
        <span class="toast-text">{{ toast.message }}</span>
        <span class="toast-close" @click="hideToast">×</span>
      </div>
    </div>

  </div>
</template>

<script>
import request from '../api/request'
import { Toast } from 'vant'
import { fetchAdDetails, resolveAdImage } from '../api/ad'
import IssuePanel from './IssuePanel.vue'
import HotList from './HotList.vue'
import FavoriteButton from '../../channel/components/FavoriteButton.vue'
import ShareButton from '../../channel/components/ShareButton.vue'
import HomePartners from '../../../views/home/components/HomePartners.vue'
import { getCaptchaImage } from '../api/news'

export default {
  name: 'PageMain',
  components: {
    IssuePanel,
    HotList,
    FavoriteButton,
    ShareButton,
    HomePartners
  },
  data() {
    return {
      fontSize: 16,
      defaultFontSize: 16,
      imgPageDescFontSize: '14px',  // 图片描述默认字号
      recommendList: [],
      commentText: '',
      toast: {
        show: false,
        message: '',
        type: 'info',
        timer: null
      },
      userInfo: {
        nickname: '',
        avatar: '',
        userCode: ''
      },
      article: {
        title: '',
        subTitle: '',
        author: '',
        publishTimeStr: '',
        source: '',
        tags: '',
        content: '',
        coverImage: '',
        type: 1,
        viewCount: 0,
        likeCount: 0,
        commentCount: 0,
        newsImages: [],
        publisherName: '',
        approvalOneBy: '',
        approvalTwoBy: '',
        approvalThreeBy: '',
        publisherPostName: '',
      },
      // VueMeta 元数据
      pageMeta: {
        title: '',
        keywords: '',
        description: ''
      },
      showFeedbackModal: false,
      feedbackForm: {
        type: '',
        content: '',
        mobile: '',
        email: '',
        captchaCode: '',
        uuid: '',
        errors: { captcha: '' }
      },
      feedbackLoading: false,
      captchaUrl: '',
      imgPageIdx: 0,
      issueList: [],
      currentYear: new Date().getFullYear(),
      commentList: [],
      commentTotal: 0,
      commentPage: 1,
      commentPageSize: 5,
      commentHasMore: false,
      commentLoading: false,
      adList: [],
      showArticleShareQrcode: false,
      articleShareQrcodeType: 'wechat',
      wechatIcon: require('../../../assets/img/share/wechat.png'),
      qqIcon: require('../../../assets/img/share/qq.png'),
      weiboIcon: require('../../../assets/img/share/weibo.png'),
            
      // 举报弹窗数据
      reportModalData: {
        targetType: '',
        comment: null,
        type: '',
        desc: '',
        showTarget: '',
        commentIndex: -1,
        contentTargetType: ''  // 举报内容类型：1=用户头像，2=用户昵称，3=评论内容
      },
      reportLoading: false,
      showReportModalVisible: false,
      DEFAULT_IMAGE: 'https://image.cbrand.com.cn/default/2026/10/AA38368160C540F19F19189B1D3A82AE.png'
    }
  },
  metaInfo() {
    return this.getMetaInfo
  },
  computed: {
    // VueMeta 元数据
    getMetaInfo() {
      return {
        title: this.article.seoTitle || this.pageTitle || '文章详情',
        meta: [
          {
            name: 'keywords',
            content: this.article.seoKeywords || ''
          },
          {
            name: 'description',
            content: (this.article.seoDescription || '').substring(0, 200)
          }
        ]
      }
    },
    articleShareUrl() {
      const origin = window.location.origin
      const newsCode = this.$route.params.id
      return `${origin}/zp/a/${newsCode}`
    },
    articleQrcodeUrl() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(this.articleShareUrl)}`
    },
    articleQrcodeTitle() {
      return this.articleShareQrcodeType === 'qq' ? 'QQ 扫一扫分享' : '微信扫一扫分享'
    },
    articleQrcodeTip() {
      return this.articleShareQrcodeType === 'qq'
        ? '打开 QQ，扫描二维码即可分享给好友'
        : '打开微信，扫描二维码即可分享给好友'
    },
    // 页面标题
    pageTitle() {
      const articleTitle = this.article.title || ''
      const categoryName = this.article.categoryName || '频道'
      return [articleTitle, categoryName, '中国品牌网', '国家市场监督管理总局 中国品牌杂志社主办'].filter(Boolean).join(' - ')
    },
    // 举报类型选项
    reportTypes() {
      return [
        { value: '1', label: '色情低俗' },
        { value: '2', label: '暴力恐怖' },
        { value: '3', label: '违法违规' },
        { value: '4', label: '虚假/欺诈信息' },
        { value: '5', label: '骚扰辱骂' },
        { value: '6', label: '垃圾广告' },
        { value: '7', label: '隐私泄露' },
        { value: '8', label: '侵权/盗版' },
        { value: '9', label: '恶意引战' },
        { value: '10', label: '其他' }
      ]
    }
  },
  watch: {
    // 监听文章数据变化以更新 meta
    // article: {
    //   deep: true,
    //   handler() {
    //     // 强制更新 metaInfo
    //     this.$nextTick(() => {
    //       if (this.$meta) {
    //         const meta = this.getMetaInfo
    //         this.$meta().title.set(meta.title)
    //         this.$meta().refresh([meta.meta])
    //       }
    //     })
    //   }
    // },
    fontSize(val) {
      this.applyContentFontSize(val)
      // 同时更新图片描述文字的字号
      const ratio = val / this.defaultFontSize
      this.imgPageDescFontSize = (14 * ratio) + 'px'
    }
  },
  created() {
    let newsCode = this.$route.params.id
    // 去除 .html 后缀（如果有的话）
    if (newsCode && newsCode.endsWith('.html')) {
      newsCode = newsCode.replace(/\.html$/, '')
    }
    const codeToken = this.$route.query.codeToken
    console.log('[PageMain] created - $route:', { params: this.$route.params, query: this.$route.query })
    console.log('[PageMain] created - newsCode:', newsCode, 'codeToken:', codeToken)
    if (newsCode) {
      this.fetchArticle(newsCode, codeToken)
    }
    this.fetchUserInfo()
    this.loadAds()
    // 登录回调：登录后带 redirect 回来，重新加载用户信息
    const redirect = this.$route.query.loginCallback
    if (redirect) {
      this.fetchUserInfo()
    }
  },
  mounted() {
    this._observer = new IntersectionObserver((entries) => {
      const entry = entries[0]
      if (entry.isIntersecting && this.commentHasMore && !this.commentLoading) {
        // 先停止监听，防止重复触发
        this._observer.unobserve(this.$refs.commentSentinel)
        this.fetchComments(false)
      }
    }, { threshold: 0.1 })
    
    // 监听登录成功后的用户信息刷新
    console.log('[PageMain] mounting, adding refresh-user-info listener')
    window.addEventListener('refresh-user-info', this.handleRefreshUserInfo)
  },
  beforeDestroy() {
    if (this._observer) this._observer.disconnect()
    console.log('[PageMain] unmounting, removing event listeners')
    window.removeEventListener('refresh-user-info', this.handleRefreshUserInfo)
  },
  beforeRouteUpdate(to, from, next) {
    let newsCode = to.params.id
    // 去除 .html 后缀（如果有的话）
    if (newsCode && newsCode.endsWith('.html')) {
      newsCode = newsCode.replace(/\.html$/, '')
    }
    if (newsCode && newsCode !== from.params.id.replace(/\.html$/, '')) {
      this.fetchArticle(newsCode, to.query.codeToken)
    }
    next()
  },
  methods: {
    // 更新页面元数据
    // updatePageMeta() {
    //   const meta = this.getMetaInfo
    //   this.$nextTick(() => {
    //     if (this.$meta) {
    //       this.$meta().title.set(meta.title)
    //       this.$meta().refresh([meta.meta])
    //     }
    //   })
    // },
  
    // ========== 验证码相关 ==========
      async loadCaptcha() {
        try {
          const res = await getCaptchaImage()
          if (res.code === 200 && res.img) {
            this.feedbackForm.uuid = res.uuid || ''
            // img 是纯 base64 内容，需要添加前缀
            this.captchaUrl = 'data:image/png;base64,' + res.img
            console.log('✅ 验证码加载成功，长度:', this.captchaUrl.length)
          } else {
            console.warn('⚠️ 验证码获取失败:', res)
          }
        } catch (e) {
          console.error('❌ 验证码加载异常', e)
        }
      },
      // 点击反馈意见按钮：检查登录状态
      async checkLoginThenShowFeedbackModal() {
        // 先加载用户信息
        await this.fetchUserInfo()
                    
        // 如果未登录，触发全局事件显示登录窗口层
        if (!this.userInfo.userCode) {
          Toast('请先登录后再提交反馈')
          // 触发全局登录事件（由 App.vue 监听处理）
          const loginRequiredEvent = new CustomEvent('login-required', {
            detail: { redirect: window.location.pathname + window.location.search }
          })
          window.dispatchEvent(loginRequiredEvent)
          return
        }
                    
        // 已登录，加载验证码并显示反馈弹窗
        await this.loadCaptcha()
        this.showFeedbackModal = true
      },
      
      // ========== 用户信息刷新 ==========
      handleRefreshUserInfo() {
        console.log('[PageMain] refresh-user-info event received')
        this.fetchUserInfo()
      },
            
      // 提交反馈意见
      async submitFeedback() {
        this.feedbackForm.errors = { captcha: '' }
        
        if (!this.feedbackForm.type) {
           this.showToast('请选择反馈类型')
          return
        }
        if (!this.feedbackForm.captchaCode) {
          this.feedbackForm.errors.captcha = '请输入图片验证码'
           this.showToast('请输入图片验证码')
          return
        }
        // 验证手机号格式 (可选，但如果有输入则必须符合格式)
        const mobile = this.feedbackForm.mobile.trim()
        console.log('【调试】mobile:', JSON.stringify(mobile))
        if (mobile && !/^1[3-9]\d{9}$/.test(mobile)) {
          console.log('【调试】手机号格式错误')
          this.showToast('请输入正确的手机号码')
          return
        }
                
        // 验证邮箱格式 (可选，但如果有输入则必须符合格式)
        const email = this.feedbackForm.email.trim()
        console.log('【调试】email:', JSON.stringify(email))
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          console.log('【调试】邮箱格式错误')
          this.showToast('请输入正确的邮箱地址')
          return
        }
        
        console.log('【调试】验证通过，准备提交')
        
        // 防止重复提交
        if (this.feedbackLoading) {
          this.showToast('正在提交中，请稍候', 'warning')
          return
        }
        
        this.feedbackLoading = true
        try {
          const params = {
            type: parseInt(this.feedbackForm.type),
            content: this.feedbackForm.content.trim(),
            newCode: this.article.newsCode || '',
            title: this.article.title || '',
            categoryName: this.article.categoryName || '',
            newsUrl: `${window.location.origin}/zp/a/${this.article.newsCode}`,
            mobile: this.feedbackForm.mobile.trim(),
            email: this.feedbackForm.email.trim(),
            captchaCode: this.feedbackForm.captchaCode,
            uuid: this.feedbackForm.uuid
          }
      
          const res = await request({
            url: '/api/feedback/add',
            method: 'post',
            data: params
          })
          console.log('提交反馈结果', res)
          if (res.code === 200) {
            Toast('提交成功')
            this.showFeedbackModal = false
            // 重置表单
            this.feedbackForm.type = ''
            this.feedbackForm.content = ''
            this.feedbackForm.mobile = ''
            this.feedbackForm.email = ''
            this.feedbackForm.captchaCode = ''
            this.feedbackForm.uuid = ''
            this.loadCaptcha()
          } else {
             this.loadCaptcha()
             this.showToast(res.msg || '提交失败')
          }
        } catch (e) {
           this.loadCaptcha()
            this.showToast(e.message)
            console.error('提交反馈失败', e.message)
          console.error('提交反馈失败', e)
        } finally {
          this.feedbackLoading = false
        }
      },
      
      // ========== 举报功能 ==========
      toggleReportTarget(idx, target) {
        // 切换举报按钮显示
        if (this.reportModalData.showTarget === target && this.reportModalData.commentIndex === idx) {
          // 如果已经显示，点击其他地方时隐藏
          this.reportModalData.showTarget = ''
          this.reportModalData.commentIndex = -1
        } else {
          // 显示举报按钮
          this.reportModalData.showTarget = target
          this.reportModalData.commentIndex = idx
        }
      },
      
      showReportModal(type, comment) {
        // 检查登录状态
        this.fetchUserInfo().then(() => {
          if (!this.userInfo.userCode) {
            Toast('请先登录后再进行举报')
            const loginRequiredEvent = new CustomEvent('login-required', {
              detail: { redirect: window.location.pathname + window.location.search }
            })
            window.dispatchEvent(loginRequiredEvent)
            return
          }
          
          // 设置举报弹窗数据
          this.reportModalData.targetType = type
          this.reportModalData.comment = comment
          this.reportModalData.type = ''
          this.reportModalData.desc = ''
          this.reportModalData.showTarget = ''
          this.reportModalData.commentIndex = -1
          
          // 根据类型默认选中对应的举报内容
          if (type === 'userAvatar') {
            this.reportModalData.contentTargetType = '1'  // 用户头像
          } else if (type === 'userNickname') {
            this.reportModalData.contentTargetType = '2'  // 用户昵称
          } else {
            this.reportModalData.contentTargetType = '3'  // 评论内容
          }
          
          // 显示举报弹窗
          this.showReportModalVisible = true
        })
      },
      
      async submitReport() {
        // 验证举报类型
        if (!this.reportModalData.type) {
          this.showToast('请选择举报类型')
          return
        }
        
        // 验证举报内容类型
        if (!this.reportModalData.contentTargetType) {
          this.showToast('请选择举报内容')
          return
        }
        
        // 获取评论信息
        const comment = this.reportModalData.comment
        
        // 防止重复提交
        if (this.reportLoading) {
          this.showToast('正在提交中，请稍候', 'warning')
          return
        }
        
        // 构建举报参数
        const params = {
          targetType: parseInt(this.reportModalData.contentTargetType),  // 1=用户头像，2=用户昵称，3=评论内容
          targetId: comment.id,  // 被投诉对象 ID：根据 contentTargetType 不同而不同 (1=用户 userId,2=用户 userId,3=评论 id)
          targetUserId: comment.userId,  // 被投诉对象所属的 userId
          reasonType: this.reportModalData.type,  // 举报类型
          reasonContent: this.getContentTargetContent(),  // 头像 URL、昵称或评论内容
          reasonDesc: (this.reportModalData.desc || '').trim()  // 补充说明
        }
        
        try {
          this.reportLoading = true
          const res = await request.post('/api/complaint/add', params)
          if (res.code === 200) {
            Toast('举报提交成功', 'success')
            this.showReportModalVisible = false
            // 重置表单
            this.reportModalData.type = ''
            this.reportModalData.desc = ''
            this.reportModalData.contentTargetType = ''
          } else {
            this.loadCaptcha()
            this.showToast(res.msg || '举报提交失败')
          }
        } catch (e) {
          console.error('举报提交失败', e)
           this.loadCaptcha()
          this.showToast(e.message || '举报提交失败，请稍后重试', 'error')
        } finally {
          this.reportLoading = false
        }
      },
      
      // 根据举报内容类型返回对应的内容
      getContentTargetContent() {
        const comment = this.reportModalData.comment
        const type = this.reportModalData.contentTargetType
        
        if (type === '1') {
          // 用户头像
          return comment.avatar || ''
        } else if (type === '2') {
          // 用户昵称
          return comment.nickname || ''
        } else if (type === '3') {
          // 评论内容
          return comment.content || ''
        }
        return ''
      },
    goHome() {
      this.$router.push('/')
    },
    goDetail(newsCode) {
      if (newsCode) {
        window.open(`/zp/a/${newsCode}`, '_blank')
      }
    },
    goCategory(categoryId) {
      const templatePath = this.article.templatePath
      if (templatePath) {
        window.location.href = `${templatePath}?categoryId=${categoryId}`
      }
    },
    recordOriginalFontSizes() {
      const container = this.$refs.articleContent
      if (!container) return
      const map = new Map()
      container.querySelectorAll('*').forEach(el => {
        if (el.style.fontSize) {
          map.set(el, el.style.fontSize)
        }
      })
      this._originalFontSizes = map
    },
    applyContentFontSize(newSize) {
      const map = this._originalFontSizes
      if (!map || map.size === 0) return
      const ratio = newSize / this.defaultFontSize
      map.forEach((originalValue, el) => {
        const originalNum = parseFloat(originalValue)
        if (originalNum && !isNaN(originalNum)) {
          const unit = originalValue.replace(/[\d.]+/, '') || 'px'
          el.style.fontSize = (originalNum * ratio) + unit
        }
      })
    },
    async loadAds() {
      const list = await fetchAdDetails('detail_hot_btm')
      console.log('[PageMain] loadAds - list:', list)
      this.adList = (list || []).map(item => ({
        imageUrl: resolveAdImage(item.imageUrl),
        turnUrl: item.turnUrl || '#',
        textTip: item.textTip || '广告',
        isShowTag: item.isShowTag
      }))
    },
    async fetchArticle(newsCode, codeToken) {
      try {
        const params = { newsCode }
        const token = codeToken || this.$route.query.codeToken
        console.log('[PageMain] fetchArticle - newsCode:', newsCode, 'codeToken param:', codeToken, 'query:', this.$route.query.codeToken)
        if (token) {
          params.codeToken = token
          console.log('[PageMain] Adding codeToken to request:', token)
        }
        const res = await request.post('/api/news/detail', params)
        const data = res.data || {}
        // 无数据或数据异常时跳转到 404
        if (!data || !data.id) {
          this.$router.replace('/404')
          return
        }
        // turnUrlEnabled=1 时：判断是否是外部链接
        if (data.turnUrlEnabled === 1 && data.turnUrl) {
          // 外链直接跳转，不做任何提示
          window.location.href = data.turnUrl
          return
        }
        // 格式化发布时间
        let publishTimeStr = ''
        if (data.publishTime) {
          publishTimeStr = typeof data.publishTime === 'string'
            ? data.publishTime.slice(0, 16)
            : new Date(data.publishTime).toLocaleString('zh-CN', { hour12: false }).slice(0, 16)
        }
        this.article = {
          ...data,
          publishTimeStr,
          relativeTime: this.formatRelativeTime(data.publishTime),
          newsImages: data.newsImages || [],
          publisherPostName: data.publisherPostName || '',
        }
        this.imgPageIdx = 0
        // 文章内容渲染后记录内联 font-size
        this.$nextTick(() => {
          this.recordOriginalFontSizes()
          // 文章加载完成后更新页面标题和 meta
          //this.updatePageMeta()
        })
        // 加载当前文章分类的推荐新闻
        if (data.categoryId) {
          this.fetchRecommendList(data.categoryId)
          this.$emit('category-loaded', data.categoryId)
        }
        // 文章加载完成后拉取评论
        if (data.id) {
          this.fetchComments(true)
        }
      } catch (e) {
        console.error('文章加载失败', e)
        this.$router.replace('/404')
      }
    },
    async fetchUserInfo() {
      const token = localStorage.getItem('token')
      console.log('[PageMain] fetchUserInfo called, token exists:', !!token)
      if (!token) {
        this.userInfo = { nickname: '', avatar: '', userCode: '' }
        return
      }
      
      try {
        const userType = localStorage.getItem('userType') || 'personal'
        let data = {}
        
        if (userType === 'company') {
          // 企业账号
          const res = await request.post('/api/company/home/getCompanyInfo')
          data = res.data || {}
          this.userInfo = {
            nickname: data.companyShortName || '',
            avatar: data.avatar || '',
            userCode: data.companyCode || ''
          }
        } else {
          // 个人账号（默认）
          const res = await request.post('/api/member/home/getUserInfo')
          data = res.data || {}
          this.userInfo = {
            nickname: data.nickname || '',
            avatar: data.avatar || '',
            userCode: data.userCode || ''
          }
        }
        
        console.log('[PageMain] User info loaded:', this.userInfo)
      } catch (e) {
        console.error('[PageMain] Failed to fetch user info:', e)
        // token 无效或过期，清除
        localStorage.removeItem('token')
        this.userInfo = { nickname: '', avatar: '', userCode: '' }
      }
    },
    goLogin() {
      // 直接触发全局登录事件，由 PageHeader 管理登录弹窗
      console.log('[PageMain] goLogin called, triggering login event')
      const loginRequiredEvent = new CustomEvent('login-required', {
        detail: { redirect: window.location.pathname + window.location.search }
      })
      window.dispatchEvent(loginRequiredEvent)
    },
    handleLoginSuccess() {
      // 此方法不再直接使用，由全局事件处理
      // 仅保留用于其他可能的调用
      this.fetchUserInfo()
      this.$nextTick(() => {
        this.focusComment()
      })
    },
    // 聚焦评论输入框
    focusComment() {
      this.$nextTick(() => {
        const el = this.$refs.commentInput
        if (el) el.focus()
      })
    },
    formatRelativeTime(time) {
      if (!time) return ''
      const now = Date.now()
      const t = typeof time === 'string' ? new Date(time.replace(/-/g, '/')).getTime() : new Date(time).getTime()
      if (isNaN(t)) return time
      const diff = Math.floor((now - t) / 1000)
      if (diff < 60) return '刚刚'
      if (diff < 3600) return Math.floor(diff / 60) + '分钟前'
      if (diff < 86400) return Math.floor(diff / 3600) + '小时前'
      if (diff < 2592000) return Math.floor(diff / 86400) + '天前'
      const d = new Date(t)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    },
    getSource(source) {
      if (!source) return ''
      const truncated = source.split('|')[0]
      return this.truncateSevenChars(truncated)
    },
    truncateSevenChars(str) {
      if (!str) return ''
      if (str.length <= 7) return str
      return str.slice(0, 7) + '...'
    },
    async fetchRecommendList(categoryId) {
      if (!categoryId) return
      try {
        const params = { categoryId }
        const res = await request.post('/api/news/listS4', params)
        const data = res.data
        const list = Array.isArray(data) ? data : (data.rows || data.list || data.records || [])
        this.recommendList = list.slice(0, 4)
      } catch (e) {
        console.error('推荐新闻加载失败', e)
      }
    },
    goArticle(newsCode) {
      if (!newsCode) return
      window.open(`/zp/a/${newsCode}`, '_blank')
    },

    async submitComment() {
      const content = this.commentText.trim()
      if (!content) return
      
      // 检查登录状态
      await this.fetchUserInfo()
      if (!this.userInfo.userCode) {
        Toast('请先登录后再发表评论')
        // 触发全局登录事件
        const loginRequiredEvent = new CustomEvent('login-required', {
          detail: { redirect: window.location.pathname + window.location.search }
        })
        window.dispatchEvent(loginRequiredEvent)
        return
      }
      
      if (!this.article.id) {
        this.showToast('文章信息未加载，请稍后再试', 'warning')
        return
      }
      
      // 防止重复提交
      if (this.commentLoading) {
        this.showToast('正在发表中，请稍候', 'warning')
        return
      }
      
      this.commentLoading = true
      try {
        await request.post('/api/member/comment/add', {
          content,
          newsId: this.article.id
        })
        this.commentText = ''
        this.showToast('评论发表成功', 'success')
        // 刷新评论列表 - 清除加载状态后再刷新，避免冲突
        setTimeout(() => {
          this.commentLoading = false
          this.fetchComments(true)
        }, 100)
      } catch (e) {
        console.error('评论发表失败', e)
        // request.js 拦截器已经将错误信息转为 error.message
        this.showToast(e.message || '评论发表失败，请稍后重试', 'error')
      } finally {
        this.commentLoading = false
      }
    },
    async fetchComments(reset = false) {
      if (!this.article.id) return
      if (this.commentLoading) return
      this.commentLoading = true
      try {
        const page = reset ? 1 : this.commentPage
        const res = await request.post('/api/comment/getCommentList', {
          pageNum: page,
          pageSize: this.commentPageSize,
          newsId: this.article.id
        })
        const data = res.data || {}
        const list = (data.rows || data.list || data.records || []).map(item => ({
          ...item,
          showReply: false,
          replyText: ''
        }))
        if (reset) {
          this.commentList = list
          this.commentPage = 2
        } else {
          this.commentList = this.commentList.concat(list)
          this.commentPage++
        }
        this.commentTotal = data.total || 0
        this.commentHasMore = this.commentList.length < this.commentTotal
        // 有更多数据时才重新监听哨兵，否则停止
        this.$nextTick(() => {
          if (this._observer && this.$refs.commentSentinel) {
            if (this.commentHasMore) {
              this._observer.observe(this.$refs.commentSentinel)
            } else {
              this._observer.disconnect()
            }
          }
        })
      } catch (e) {
        console.error('评论加载失败', e)
      } finally {
        this.commentLoading = false
      }
    },

    async toggleLike(idx) {
      const c = this.commentList[idx]
          
      // 检查登录状态
      await this.fetchUserInfo()
      if (!this.userInfo.userCode) {
        Toast('请先登录后再进行互动')
        const loginRequiredEvent = new CustomEvent('login-required', {
          detail: { redirect: window.location.pathname + window.location.search }
        })
        window.dispatchEvent(loginRequiredEvent)
        return
      }
          
      // 已顶 → 取消顶 (2)；未顶 → 顶 (1)，若已踩则同步取消踩
      const actionType = c.isUp === 1 ? 2 : 1
      try {
        await request.post('/api/comment/voteComment', { commentId: c.id, actionType })
        if (c.isUp === 1) {
          this.$set(c, 'isUp', 0); this.$set(c, 'upCount', c.upCount - 1)
        } else {
          this.$set(c, 'isUp', 1); this.$set(c, 'upCount', c.upCount + 1)
          if (c.isDown === 1) { this.$set(c, 'isDown', 0); this.$set(c, 'downCount', c.downCount - 1) }
        }
      } catch (e) {
        this.showToast('操作失败，请稍后重试', 'error')
      }
    },
    async toggleDislike(idx) {
      const c = this.commentList[idx]
          
      // 检查登录状态
      await this.fetchUserInfo()
      if (!this.userInfo.userCode) {
        Toast('请先登录后再进行互动')
        const loginRequiredEvent = new CustomEvent('login-required', {
          detail: { redirect: window.location.pathname + window.location.search }
        })
        window.dispatchEvent(loginRequiredEvent)
        return
      }
          
      // 已踩 → 取消踩 (4)；未踩 → 踩 (3)，若已顶则同步取消顶
      const actionType = c.isDown === 1 ? 4 : 3
      try {
        await request.post('/api/comment/voteComment', { commentId: c.id, actionType })
        if (c.isDown === 1) {
          this.$set(c, 'isDown', 0); this.$set(c, 'downCount', c.downCount - 1)
        } else {
          this.$set(c, 'isDown', 1); this.$set(c, 'downCount', c.downCount + 1)
          if (c.isUp === 1) { this.$set(c, 'isUp', 0); this.$set(c, 'upCount', c.upCount - 1) }
        }
      } catch (e) {
        this.showToast('操作失败，请稍后重试', 'error')
      }
    },
    toggleReply(idx) {
      const c = this.commentList[idx]
      this.$set(c, 'showReply', !c.showReply)
      if (!c.showReply) this.$set(c, 'replyText', '')
    },
    async submitReply(idx) {
      const c = this.commentList[idx]
      const content = (c.replyText || '').trim()
      if (!content) return
      
      // 检查登录状态
      await this.fetchUserInfo()
      if (!this.userInfo.userCode) {
        Toast('请先登录后再进行回复')
        const loginRequiredEvent = new CustomEvent('login-required', {
          detail: { redirect: window.location.pathname + window.location.search }
        })
        window.dispatchEvent(loginRequiredEvent)
        return
      }
      
      try {
        await request.post('/api/member/comment/reply', {
          parentId: c.id,
          content
        })
        this.$set(c, 'replyText', '')
        this.$set(c, 'showReply', false)
        this.showToast('回复成功', 'success')
        // 刷新评论列表以显示最新回复
        this.fetchComments(true)
      } catch (e) {
        console.error('回复失败', e)
        this.showToast('回复失败，请稍后重试', 'error')
      }
    },
    copyArticleLink() {
      const url = this.articleShareUrl
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          Toast('链接已复制')
        }).catch(() => {
          this.fallbackCopyArticleLink(url)
        })
      } else {
        this.fallbackCopyArticleLink(url)
      }
    },
    fallbackCopyArticleLink(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        Toast('链接已复制')
      } catch (e) {
        Toast('复制失败，请手动复制')
      }
      document.body.removeChild(textarea)
    },
    shareArticleWechat() {
      this.articleShareQrcodeType = 'wechat'
      this.showArticleShareQrcode = true
    },
    shareArticleQQ() {
      this.articleShareQrcodeType = 'qq'
      this.showArticleShareQrcode = true
    },
    shareArticleWeibo() {
      const url = encodeURIComponent(this.articleShareUrl)
      const title = encodeURIComponent(this.article.title || '分享文章')
      window.open(
        `http://service.weibo.com/share/share.php?url=${url}&title=${title}`,
        '_blank'
      )
    },
    showToast(message, type = 'info') {
      if (this.toast.timer) clearTimeout(this.toast.timer)
      this.toast.show = true
      this.toast.message = message
      this.toast.type = type
      this.toast.timer = setTimeout(() => { this.hideToast() }, 3000)
    },
    hideToast() {
      this.toast.show = false
      if (this.toast.timer) clearTimeout(this.toast.timer)
    },
    openTurnUrl() {
      window.location.href = this.turnUrlModal.url
    },
    // 判断 URL 是否与当前页面同域
    isSameOriginUrl(url) {
      try {
        const currentOrigin = window.location.origin
        const parsedUrl = new URL(url)
        return parsedUrl.origin === currentOrigin
      } catch (e) {
        console.error('URL 解析失败:', e)
        return false
      }
    },
    // 判断是否为内部链接（没有域名）
    isInternalUrl(url) {
      if (!url) return false
      
      // 如果是空白字符串，不是内部链接
      if (!url.trim()) return false
      
      // 检查是否以协议开头（http://, https://）
      const hasProtocol = /^https?:\/\/.+/.test(url)
      
      // 不以 http/https 开头的都是内部链接
      return !hasProtocol
    }
  }
}
</script>

<style scoped>
.text_22 {
  white-space: normal;
  word-break: break-word;
  line-height: 1.5;
  text-align: left !important;
  margin-left: 0px;
}

/* 文章作者/发布时间左对齐，来源右对齐 */
.text-wrapper_3.article-meta-row {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  text-align: left !important;
  width: 1040px !important;
  margin-left: 0px !important;
}
.article-meta-left {
  display: flex;
  align-items: center;
}
.article-meta-left .text_23,
.article-meta-left .text_24,
.article-meta-left .text_25,
.article-meta-source {
  width: auto !important;
  height: auto !important;
  display: inline-block !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 24px !important;
}
.article-meta-source {
  margin-left: auto;
}

/* 覆盖固定高度，让标题区自适应内容高度 */
.box_65 {
  height: auto !important;
  min-height: 0 !important;
  justify-content: flex-start !important;
  gap: 0;
}
.text-group_42 {
  height: auto !important;
  min-height: 0 !important;
}
/* 小红块紧跟标题区，居中显示 */
.block_5 {
  position: relative !important;
  margin: 16px auto 0 !important;
}
/* 字体切换工具栏右对齐 */
.box_48 {
  position: relative !important;
  margin-top: 12px !important;
  margin-left: auto !important;
  margin-right: 0 !important;
}

.article-approval-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 8px;
  margin-top: 20px;
  padding-top: 12px;
  border-top: 1px solid #eee;
  font-size: 13px;
  color: #999;
  width: 100%;
}
.article-approval-bar span + span::before {
  content: ' | ';
  color: #ddd;
}

.feedback-btn {
  padding: 6px 16px;
  border: 1px solid #23B4DC;
  background: #fff;
  color: #23B4DC;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
  line-height: 1.5;
}

.feedback-btn:hover {
  background: #23B4DC;
  color: #fff;
}

.article-subtitle {
  display: block;
  width: 990px;
  font-size: 20px;
  color: #666;
  line-height: 1.6;
  margin-top: 10px;
  word-break: break-word;
  white-space: normal;
  text-align: left;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  color: #666;
  font-size: 14px;
}
.home-link {
  color: rgba(51, 51, 51, 1);
  cursor: pointer;
  transition: color 0.2s;
}
.home-link:hover {
  color: rgba(160, 0, 0, 1);
  text-decoration: underline;
}
.sep {
  color: #999;
}
.channel-link {
  cursor: pointer;
  transition: color 0.2s;
}
.channel-link:hover {
  color: rgba(191, 75, 74, 1);
  text-decoration: underline;
}

.page-main {
  width: 1400px;
  margin-top: 14px;
}
.main-body {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 35px;
  width: 1400px;
}
.main-left {
  width: 1042px;
  flex-shrink: 0;
}
.main-right {
  width: 323px;
  flex-shrink: 0;
}
/* 左侧固定分享面板 */
.article-share-panel {
  position: fixed;
  left: calc((100vw - 1400px) / 2 - 120px);
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  z-index: 100;
  background: #f5f5f7;
  border-radius: 8px;
  padding: 16px 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
.article-share-panel .share-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #666;
  transition: color 0.2s;
}
.article-share-panel .share-item:hover {
  color: #C00513;
}
.article-share-panel .share-item-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

/* 推荐新闻卡片 */
.recommend-card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 29px;
}
.recommend-card {
  width: 238px;
  height: 296px;
  background: rgba(245, 245, 247, 1);
  overflow: hidden;
  border: 1px solid rgba(226, 226, 227, 1);
  box-sizing: border-box;
  transition: all 0.2s ease;
}
.recommend-image-wrap,
.recommend-title {
  cursor: pointer;
}
.recommend-card:hover {
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}
.recommend-card:hover .recommend-title {
  color: #C00513;
}
.recommend-image-wrap {
  position: relative;
  width: 100%;
  height: 133px;
  overflow: hidden;
}
.recommend-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.recommend-info {
  display: flex;
  align-items: center;
  margin: 14px 14px 0;
  font-size: 12px;
  color: #999;
}
.recommend-category {
  max-width: 118px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #999;
}

.recommend-time {
  color: #999;
}
.recommend-title {
  font-size: 18px;
  color: #333;
  line-height: 30px;
  margin: 8px 14px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 60px;
  box-sizing: border-box;
  transition: color 0.2s;
}
.recommend-actions {
  margin: auto 14px 16px;
  gap: 24px;
}

.sidebar-ads {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}
.sidebar-ad-item {
  display: block;
  width: 100%;
}
.sidebar-ad-img {
  width: 100%;
  display: block;
  object-fit: cover;
}
.sidebar-ad-item {
  position: relative;
  display: block;
}
.sidebar-ad-tag {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 0 4px 0 4px;
  line-height: 1.5;
}

/* 图页模式 */
.img-page-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.img-page-viewer {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 12px;
}
.img-page-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.img-page-img {
  width: 100%;
  max-height: 560px;
  object-fit: contain;
  display: block;
}
.img-page-desc {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 1.6;
}
.img-page-arrow {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  transition: background 0.2s;
}
.img-page-arrow:hover:not(:disabled) {
  background: #f0f0f0;
}
.img-page-arrow:disabled {
  color: #ccc;
  cursor: not-allowed;
  border-color: #eee;
}
.img-page-counter {
  margin-top: 10px;
  font-size: 14px;
  color: #999;
}

/* 评论撰写区整体行 */
.comment-write-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 4px;
}
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  margin-top: 2px;
}
/* 右侧：昵称 + 输入框紧凑排列 */
.comment-write-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.comment-user-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  line-height: 1.2;
}
/* 未登录提示与头像对齐 */
.comment-nologin-tip {
  font-size: 14px;
  color: #666;
  align-self: center;
}
/* 未登录整体行：头像左，右侧灰色框 */
.comment-nologin-row {
  align-items: flex-start;
}
.comment-nologin-box {
  flex: none;
  width: 920px;
  height: 140px;
  background: rgba(249, 249, 249, 1);
  border: 1px solid rgba(232, 232, 232, 1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #999;
}
.comment-login-link {
  color: #4a90e2;
  cursor: pointer;
  font-weight: 600;
  margin-left: 4px;
  margin-right: 4px;
}
.comment-login-link:hover {
  text-decoration: underline;
}


/* 单条评论容器 */
.comment-item {
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
}
.comment-item:last-child {
  border-bottom: none;
}
/* 评论列表头像 */
.ci-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  margin-right: 12px;
  margin-top: 0;
}
/* 评论右侧内容列 */
.ci-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0;
}
/* 昵称 */
.text_59 {
  font-size: 15px;
  font-weight: 600;
  color: #222;
  line-height: 1.4;
  margin-bottom: 4px;
}
/* 评论内容 */
.text_60 {
  font-size: 15px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 6px;
}
/* 时间 + 操作行 */
.comment-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin-top: 0;
}
.comment-time {
  font-size: 12px;
  color: #aaa;
  white-space: nowrap;
}
.action-btns {
  display: flex;
  gap: 8px;
}
.action-btn {
  /* color: #999; */
  font-size: 13px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}
.action-btn:hover {
  color: #C00513;
}

.text_57.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
/* 嵌套回复列表 */
.reply-list {
  margin-top: 8px;
  background: rgba(249, 249, 249, 1);
  border-radius: 6px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.reply-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
}
.reply-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.reply-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.reply-nickname {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}
.reply-content {
  font-size: 13px;
  color: #555;
  line-height: 1.5;
}
.reply-time {
  font-size: 12px;
  color: #999;
}
/* 加载更多 */
.comment-sentinel {
  height: 1px;
  margin-top: 8px;
}
.comment-loading {
  text-align: center;
  color: #999;
  font-size: 13px;
  padding: 8px;
}

/* 登录弹窗 */
.login-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9998;
}

/* 文章分享二维码弹层 */
.qrcode-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.qrcode-box {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.qrcode-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.qrcode-img {
  width: 200px;
  height: 200px;
}
.qrcode-tip {
  font-size: 12px;
  color: #999;
}
.qrcode-close {
  margin-top: 4px;
  padding: 6px 24px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.qrcode-close:hover {
  background: #f5f5f5;
}

/* Toast 弹层 */
.toast-mask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.toast-content {
  min-width: 240px;
  max-width: 420px;
  padding: 14px 24px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.toast-content.success { border-left: 4px solid rgba(82, 196, 26, 1); }
.toast-content.error { border-left: 4px solid rgba(228, 2, 16, 1); }
.toast-content.warning { border-left: 4px solid rgba(250, 173, 20, 1); }
.toast-content.info { border-left: 4px solid rgba(24, 144, 255, 1); }
.toast-text {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-family: Microsoft YaHei, sans-serif;
  line-height: 1.5;
}
.toast-close {
  font-size: 18px;
  color: rgba(153, 153, 153, 1);
  cursor: pointer;
  line-height: 1;
}
.toast-close:hover { color: rgba(51, 51, 51, 1); }

/* 外链跳转弹窗 */
.turn-url-mask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.turn-url-box {
  background: #fff;
  border-radius: 12px;
  padding: 32px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  min-width: 320px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.15);
}
.turn-url-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
.turn-url-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
.turn-url-btns {
  display: flex;
  gap: 16px;
  margin-top: 8px;
}
.turn-url-btn {
  padding: 8px 28px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s;
}
.turn-url-btn:hover { opacity: 0.85; }
.turn-url-btn-primary {
  background: #C00513;
  color: #fff;
}
.turn-url-btn-cancel {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}

/* ========== 反馈意见弹窗 ========== */
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.feedback-modal {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  width: 90%;
  max-width: 520px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
}

.feedback-title {
  margin: 0 0 24px 0;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #333;
}

.feedback-row {
  margin-bottom: 12px;
}

.feedback-label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 6px;
  font-weight: 500;
}

.input-wrapper {
  margin-top: 6px;
}

.required {
  color: #ff4d4f;
  margin-left: 2px;
}

.feedback-options {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.radio-option {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.radio-option input[type="radio"] {
  margin-right: 6px;
}

.feedback-row textarea {
  width: 100%;
  min-height: 80px;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  font-family: inherit;
  box-sizing: border-box;
}

.feedback-row textarea:focus,
.feedback-row input:focus {
  outline: none;
  border-color: #23B4DC;
  box-shadow: 0 0 0 2px rgba(35, 180, 220, 0.1);
}

.char-count {
  font-size: 12px;
  color: #999;
  text-align: right;
  margin-bottom: 8px;
}

/* ========== 普通输入框样式 ========== */
.feedback-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.feedback-row textarea,
.feedback-row input.feedback-input {
  display: block;
  width: 100%;
}

/* ========== 验证码行 ========== */
.captcha-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.captcha-input {
  flex: 1;
}

.captcha-img {
  width: 100px;
  height: 40px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  background: #f5f5f5;
}

.captcha-error {
  font-size: 12px;
  color: #ff4d4f;
  margin-top: 4px;
}

.feedback-tip {
  font-size: 12px;
  color: #ff4d4f;
  margin: 16px 0;
}

.feedback-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
}

.feedback-actions .btn-submit,
.feedback-actions .btn-cancel {
  padding: 10px 32px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-submit {
  background: #23B4DC;
  color: #fff;
  border: none;
}

.btn-submit:hover {
  background: #1CA3C9;
}

.btn-cancel {
  background: #fff;
  color: #333;
  border: 1px solid #d9d9d9;
}

.btn-cancel:hover {
  border-color: #23B4DC;
  color: #23B4DC;
}

</style>